export default "/images/target.svg?e999a3005d91c827aa26f3f1393686ba";